import React, { Component } from 'react'
import { Button, Col, Row } from 'reactstrap'
import Card from '../../comum/components/Card'
import { observer } from 'mobx-react'
import FormSelectSimples from '../../comum/components/FormSelectSimples'
import { IconeCarregar } from '../../comum/components/Icones'

@observer
export default class FiltroBigPicture extends Component {

    constructor(props) {
        super(props)

        this.controller = this.props.controller
    }

    render() {
        return (
            <div className="filtro-card filtros-cabotagem">
                <Card className={`area-form pb-0`}>
                    <Row className="pb-0">
                        <FormSelectSimples titulo ="Mês" xs={12} sm={12} md={4} lg={4} xl={3} 
                            itens={this.controller.listaMeses}
                            dado={this.controller.mesSelecionado}
                            onChange={this.controller.setMes}
                        />
                        <FormSelectSimples titulo ="Ano" xs={12} sm={12} md={4} lg={4} xl={3} 
                            itens={this.controller.listaAnos}
                            dado={this.controller.anoSelecionado}
                            onChange={this.controller.setAno}
                            bloqueado={this.controller.listaAnos.length === 0}
                        />
                        <FormSelectSimples titulo ="Cliente" xs={12} sm={12} md={4} lg={4} xl={3} 
                            itens={this.controller.listaClientes}
                            dado={this.controller.clienteSelecionado}
                            onChange={this.controller.setCliente}
                            bloqueado={this.controller.listaClientes.length === 0}
                        />
                        <Col className="col-botoes">
                            <Button
                                disabled={this.controller.loadingRelatorio}
                                className="btn-com-bordas-primary btn-filtrar"
                                onClick={() => this.controller.pesquisar()}>
                                    {
                                    this.controller.loadingRelatorio
                                    ?<IconeCarregar cor="#fff" className="my-0" tamanho="1x" />
                                    :"Pesquisar"
                                    }
                                </Button>
                        </Col>
                    </Row>
                </Card>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/bigpicture/components/FiltroBigPicture.js